export default "__VITE_ASSET__BlLpVORu__"